import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { environmentConfig } from '../../environment';
import { getAuth } from 'firebase/auth';
import { Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WelaraMinutesService {
  private apiUrl = environmentConfig.apiBaseUrl;

  constructor(private http: HttpClient, private authService: AuthService) {}

  private fetchAuthenticated(url: string, method: 'GET' | 'POST' | 'PUT', token: any, bodyData?: any,): Observable<any> {
    const auth = getAuth();
    const user = auth.currentUser;

    //console.log("fetchAuthenticated Variables", auth, user, token)

    return new Observable<any>(observer => {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ` + token
      });

      const httpOptions = { headers };
      let httpCall: Observable<any>;

      if (method === 'GET') {
        httpCall = this.http.get(url, httpOptions);
      } else if (method === 'POST') {
        httpCall = this.http.post(url, bodyData, httpOptions);
      } else if (method === 'PUT') {
        httpCall = this.http.put(url, bodyData, httpOptions);
      } else {
        observer.error('Unsupported method');
        return;
      }

      httpCall.subscribe({
        next: data => {
          console.log('✅ Response:', data);
          observer.next(data);
        },
        error: err => {
          console.error('❌ HTTP Error:', err);
          observer.error(err);
        },
        complete: () => observer.complete()
      });
    });
  }



  saveMinutes(pkg: object, token: any): Promise<any> {
    const url = `${this.apiUrl}/api/minutes/save_minutes`;
    return this.fetchAuthenticated(url, 'POST', token, pkg).toPromise();
  }
  deleteMinutes(pkg: object, token: any): Promise<any> {
    const url = `${this.apiUrl}/api/minutes/delete?id=${pkg}`;
    return this.fetchAuthenticated(url, 'GET', token).toPromise();
  }

  loadUXData(token: any): Promise<any> {
    const url = `${this.apiUrl}/api/minutes/load_minutes`;
    return this.fetchAuthenticated(url, 'GET', token).toPromise();
  }

  trackByFn(index: any, record: any) {
    return record.id
  }
}
